var render = function render(_c,_vm){return (_vm.props.direction === 'horizontal')?_c('transition',{attrs:{"appear":_vm.props.appear,"css":false},on:{"enter":_vm.$options.methods.enterWidth,"leave":_vm.$options.methods.leaveWidth}},[_vm._t("default")],2):_c('transition',{attrs:{"appear":_vm.props.appear,"css":false},on:{"enter":_vm.$options.methods.enter,"leave":_vm.$options.methods.leave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }